module.exports = __webpack_public_path__ + "img/a37bda6.jpg";